var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 34.559,
    viewBox: "0 0 40 34.559",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "us",
    transform: "translate(-177.804 -204.763)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9257",
    "data-name": "Path 9257",
    d: "M197.783,207.883a7.953,7.953,0,0,0-7.128,11.334,7.853,7.853,0,0,0,14.295,0,7.937,7.937,0,0,0-7.167-11.334Zm-13.089,31.433a.956.956,0,0,1-.886-1.06H183.8a14.183,14.183,0,0,1,2.03-7.33h-7.072a.951.951,0,0,1-.954-1.043,11.127,11.127,0,0,1,7.223-10.431c-6.971-3.937-4.172-14.687,3.78-14.687a7.683,7.683,0,0,1,5.165,1.991,9.817,9.817,0,0,1,7.661,0,7.766,7.766,0,0,1,12.932,5.849,7.869,7.869,0,0,1-3.988,6.848,11.109,11.109,0,0,1,7.223,10.521.953.953,0,0,1-.954.954h-7.116a14.92,14.92,0,0,1,2.075,7.442.953.953,0,0,1-.954.954Zm2.518-10.3a14.018,14.018,0,0,1,6.388-4.24,9.848,9.848,0,0,1-4.346-4.088,9.125,9.125,0,0,0-9.5,8.328ZM202,224.791a13.986,13.986,0,0,1,6.36,4.228h7.5a9.125,9.125,0,0,0-9.5-8.328,9.882,9.882,0,0,1-4.363,4.1Zm7.835,12.624c-.69-10.336-13.224-15.242-20.587-7.8a12.37,12.37,0,0,0-3.5,7.8Zm-2.58-18.893a5.957,5.957,0,0,0,3.7-10.117,5.817,5.817,0,0,0-7.526-.65,9.927,9.927,0,0,1,3.83,10.767Zm-15.058-10.768a5.909,5.909,0,1,0-3.831,10.768,9.93,9.93,0,0,1,3.831-10.768Z",
    transform: "translate(0 0)",
    fill: "#272d3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9258",
    "data-name": "Path 9258",
    d: "M338.862,328.861a.952.952,0,0,1,1.694.869,4.891,4.891,0,0,1-8.7,0,.949.949,0,0,1,1.688-.869A2.987,2.987,0,0,0,338.862,328.861Z",
    transform: "translate(-138.398 -111.112)",
    fill: "#272d3b"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.d1b65aa528d99fc24a2fce902ff26d35.svg";
export { ForwardRef as ReactComponent };